import { VStack } from "@gluestack-ui/themed";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Text } from "@repo/core/components/core/Text";
import { SelectControlled } from "@repo/core/components/forms/SelectControlled";
import { ProgressBar } from "@repo/core/components/layout/ProgressBar";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";

import { ProfessionDataFormController } from "./controller";

const ProfessionDataForm = () => {
  const {
    control,
    handleOnSubmitForm,
    handleGoBack,
    handleClose,
    professions,
    professionalCategories
  } = ProfessionDataFormController();

  return (
    <PageScaffold
      onBackPress={handleGoBack}
      showBackButtonOnWeb
      onPressRightIcon={handleClose}
      rightWebLabel="Fechar"
      title="Proposta de Crédito"
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryOnPress={handleOnSubmitForm}
        />
      }
    >
      <VStack w="$full" gap="$4" pb="$4">
        <ProgressBar progress={60} />
        <Text>Dados profissionais:</Text>

        <SelectControlled
          control={control}
          isRequired
          label="Categoria Profissional"
          name="professionalCategory"
          options={professionalCategories || []}
          placeholder="Selecione a categoria"
        />

        <SelectControlled
          control={control}
          isRequired
          label="Profissão"
          name="profession"
          placeholder="Digite a profissão"
          options={professions || []}
        />

        <InputControlled
          control={control}
          isRequired
          label="Data de Admissão"
          keyboardType="number-pad"
          name="admissionDate"
          placeholder="ex: 01/01/2024"
          mask="date"
          useMaskValue
        />

        <InputControlled
          control={control}
          isRequired
          label="Renda"
          name="income"
          placeholder="Digite a renda"
          keyboardType="number-pad"
          isCurrency
        />
      </VStack>
    </PageScaffold>
  );
};

export default ProfessionDataForm;
